import { BuildingState } from './-types'

export default {}
